import React, { useEffect } from 'react';
import toastError from "../../errors/toastError";

import Typography from "@material-ui/core/Typography";

import { Button, Divider, } from "@material-ui/core";

const LocationPreview = ({ image, link, description }) => {
    useEffect(() => {}, [image, link, description]);

    const handleLocation = async() => {
        try {
            window.open(link);
        } catch (err) {
            toastError(err);
        }
    }

    return (
		<>
			<div style={{
				minWidth: "280px",
				maxWidth: "360px",
			}}>
				<div>
					<div
						onClick={handleLocation}
						style={{
							width: "100%",
							height: "138px",
							borderRadius: "12px 12px 6px 6px",
							overflow: "hidden",
							cursor: link ? "pointer" : "default",
							border: "1px solid rgba(0, 121, 107, 0.20)",
							background:
								"linear-gradient(135deg, rgba(189,232,223,0.92), rgba(223,247,242,0.92)), repeating-linear-gradient(0deg, transparent 0 31px, rgba(0,121,107,0.14) 31px 32px), repeating-linear-gradient(90deg, transparent 0 31px, rgba(0,121,107,0.14) 31px 32px)",
							position: "relative",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						{image ? (
							<img
								src={image}
								alt="Localização"
								style={{
									width: "100%",
									height: "100%",
									objectFit: "cover",
									display: "block",
								}}
							/>
						) : null}
						<div
							style={{
								position: "absolute",
								width: "44px",
								height: "44px",
								borderRadius: "50% 50% 50% 0",
								background: "#00897b",
								transform: "rotate(-45deg)",
								boxShadow: "0 10px 22px rgba(0,0,0,0.22)",
							}}
						/>
						<div
							style={{
								position: "absolute",
								width: "18px",
								height: "18px",
								borderRadius: "50%",
								background: "#fff",
								boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
							}}
						/>
					</div>
					{ description && (
					<div style={{ display: "flex", flexWrap: "wrap", padding: "10px 2px 6px" }}>
						<Typography style={{ margin: "0 10px", fontWeight: 600 }} variant="subtitle1" color="primary" gutterBottom>
							{String(description).split("\n").map((line, index) => (
								<React.Fragment key={`${line}-${index}`}>
									{line}
									{index < String(description).split("\n").length - 1 ? <br /> : null}
								</React.Fragment>
							))}
						</Typography>
					</div>
					)}
					<div>
						<Divider />
						<Button
							fullWidth
							color="primary"
							onClick={handleLocation}
							disabled={!link}
						>Abrir no mapa</Button>
					</div>
				</div>
			</div>
		</>
	);

};

export default LocationPreview;
